var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return true
    ? _c(
        "div",
        _vm._l(_vm.attributes, function(attribute, i) {
          return _c("div", { key: i, staticClass: "row" }, [
            _c("div", { staticClass: "col-sm-5" }, [
              _c("label", [_vm._v("Attribute")]),
              _vm._v(" "),
              _c("input", {
                staticClass: "form-control",
                class: { disabled: true },
                attrs: { disabled: true },
                domProps: { value: _vm.labelFor(attribute) }
              }),
              _vm._v(" "),
              _vm.errors[_vm.errorPrefix + "." + i + ".key"]
                ? _c("div", { staticClass: "text-danger" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.errors[_vm.errorPrefix + "." + i + ".key"][0]
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ]),
            _vm._v(" "),
            _c("div", { staticClass: "col-sm-5" }, [
              _c("label", [_vm._v("Value")]),
              _vm._v(" "),
              _c("input", {
                directives: [
                  {
                    name: "model",
                    rawName: "v-model",
                    value: attribute.value,
                    expression: "attribute.value"
                  }
                ],
                staticClass: "form-control",
                domProps: { value: attribute.value },
                on: {
                  input: [
                    function($event) {
                      if ($event.target.composing) {
                        return
                      }
                      _vm.$set(attribute, "value", $event.target.value)
                    },
                    _vm.onchange
                  ]
                }
              }),
              _vm._v(" "),
              _vm.errors[_vm.errorPrefix + "." + i + ".value"]
                ? _c("div", { staticClass: "text-danger" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(
                          _vm.errors[_vm.errorPrefix + "." + i + ".value"][0]
                        ) +
                        "\n      "
                    )
                  ])
                : _vm._e()
            ])
          ])
        }),
        0
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1ed96ce8", { render: render, staticRenderFns: staticRenderFns })
  }
}